import React, { useState } from 'react';
import { Box, Typography, Button, Grid, Paper } from '@mui/material';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import SettingsIcon from '@mui/icons-material/Settings';
import PeopleIcon from '@mui/icons-material/People';
import CandidateModal from './CandidateModal';

const ActionIcons = ({ profiles }) => {
  const [modalOpen, setModalOpen] = useState(false);
  
  const actions = [
    { label: 'Generate 5 Applications', icon: <PersonAddIcon />, count: 5 },
    { label: 'Generate 10 Applications', icon: <PersonAddIcon />, count: 10 },
    { label: 'Generate 20 Applications', icon: <PersonAddIcon />, count: 20 },
    { label: 'Custom', icon: <SettingsIcon />, count: 'custom' }
  ];

  const handleAction = (action) => {
    console.log(`Action selected: ${action.label}`);
    // Here you would implement the actual action logic
  };

  const handleOpenModal = () => {
    setModalOpen(true);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
  };

  return (
    <Box sx={{ p: 2 }}>
      <Typography variant="h6" sx={{ mb: 2, color: 'white', fontWeight: 'bold' }}>
        Actions
      </Typography>
      
      {/* See Matching Candidates Button */}
      <Box sx={{ mb: 3 }}>
        <Button
          variant="contained"
          fullWidth
          startIcon={<PeopleIcon />}
          onClick={handleOpenModal}
          sx={{
            backgroundColor: '#4A5568',
            color: 'white',
            py: 1.5,
            '&:hover': {
              backgroundColor: '#2D3748',
            }
          }}
        >
          See Matching Candidates
        </Button>
      </Box>
      
      <Grid container spacing={2}>
        {actions.map((action, index) => (
          <Grid item xs={6} key={index}>
            <Paper
              elevation={3}
              sx={{
                p: 2,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                cursor: 'pointer',
                backgroundColor: '#2D3748',
                color: 'white',
                transition: 'all 0.2s',
                '&:hover': {
                  backgroundColor: '#3B4659',
                  transform: 'translateY(-2px)'
                }
              }}
              onClick={() => handleAction(action)}
            >
              <Box sx={{ fontSize: '2rem', mb: 1 }}>
                {action.icon}
              </Box>
              <Typography variant="body2" align="center">
                {action.count === 'custom' ? 'Custom' : `Generate ${action.count}`}
              </Typography>
            </Paper>
          </Grid>
        ))}
      </Grid>
      
      {/* Candidate Modal */}
      <CandidateModal 
        open={modalOpen} 
        onClose={handleCloseModal} 
        candidates={profiles}
      />
    </Box>
  );
};

export default ActionIcons;
